import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/index.css';
import App from './App';
import ErrorBoundary from './components/common/ErrorBoundary';
import reportWebVitals from './reportWebVitals';

import "./i18n";
import { initDataSaver } from './hooks/useDataSaver';

// Reflect the stored data-saver flag onto <html> before first paint so images
// are skipped immediately rather than loading once and then disappearing.
initDataSaver();

// PWA install: the minimal service worker makes the app installable, and the
// beforeinstallprompt event MUST be captured before any component mounts —
// it fires once, early. InstallApp.js consumes window.__a2hsPrompt.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__a2hsPrompt = e;
  window.dispatchEvent(new Event('a2hs-available'));
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* OUTSIDE Suspense on purpose: this way it also catches a lazy chunk that fails to load
        (a stale tab asking for a bundle a deploy has replaced), not only errors thrown by a
        component that already mounted. Anything it does not catch is a blank page again. */}
    <ErrorBoundary>
      <React.Suspense fallback="loading...">
        <App />
      </React.Suspense>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
